import {useEffect} from 'react'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ListHeader} from './components/header/ListHeader'
import {Table} from './table/Table'
import {EditModal} from './projects-edit-modal/EditModal'
import {PageCard} from '../../../../components/design-system'
import {useQueryResponse} from './core/QueryResponseProvider'
import {on, off} from '../../../../helpers/events'

type PropTypes = {
  /** Shows the [Add User] button inside the header on the top right corner */
  showAddProject?: boolean
  /** An array of columns that you don't want shown in the user list */
  hiddenColumns?: string[]
}

export const PROJECTS_REFRESH = 'PROJECTS_REFRESH'

const List = ({showAddProject = true, hiddenColumns = []}: PropTypes) => {
  const {itemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()

  useEffect(() => {
    on(PROJECTS_REFRESH, refetch)
    return () => {
      off(PROJECTS_REFRESH, refetch)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <PageCard style={{padding: 0, overflow: 'hidden'}}>
        <ListHeader showAddProject={showAddProject} />
        <Table hiddenColumns={hiddenColumns} />
      </PageCard>
      {itemIdForUpdate !== undefined && <EditModal />}
    </>
  )
}

const CompaniesListWrapper = ({showAddProject = true, hiddenColumns = []}: PropTypes) => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <List showAddProject={showAddProject} hiddenColumns={hiddenColumns} />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {CompaniesListWrapper}
